import { create } from "zustand";

interface HookProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const useAnnouncementModal = create<HookProps>()((set) => ({
  open: false,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
